// ----------------------------------------------------------------------------
// Item List
// ----------------------------------------------------------------------------
//
// Drawer toggle for mobile
//
// ----------------------------------------------------------------------------
var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);


module.exports = function() {
    // Open children of menu items on mobile
    $('.drawer__toggle').on('click', function(event) {
        event.preventDefault();

        $toggle = $(this).siblings('.item-list__drawer');
        $(this).toggleClass('is-open');
        $toggle.toggleClass('is-open');
    });
};
